import React from "react";
import { calculateDiscountPrice } from "../../utils";
import Loader from "../Loader/Loader";
import "./styles.css";

import {
  filterFreeTicketsRates,
  getTicketPriceConsideringFreeTickets,
  filterDiscountRates,
  priceFormat,
  getFreeTickets,
  roundedPrice,
} from "../../utils/calculateDiscountAndCredits";

const labelsClassNames = {
  "MOST POPULAR": "most-popular",
  "LOWEST TICKET PRICE": "lowest-ticket-price",
};

const TicketCard = ({
  type,
  ticketBundle,
  activeTicket,
  loading,
  onClick,
  raffles,
  isExpired,
  theme,
  label,
  result,
  bonusDraw,
}) => {
  const discountsMapText = {
    10: "33% more value",
    15: "3 for 1",
    25: "3 for 1",
    30: "3 for 1",
  };
  const discountTicketsMapText = {
    5: "15",
    15: "50",
    25: "150",
  };

  const oldMapPrice = {
    "£15": "£45",
    "£25": "£75",
    "£50": "£150",
    "£75": "£225",
  };
  const bonusDrawId = bonusDraw && bonusDraw._id ? bonusDraw._id : null;
  // START OF API
  const getTotalPrice = () => {
    const price = ticketBundle.price * ticketBundle.tickets;
    return priceFormat(Math.ceil(price));
  };

  const getTicketsCount = () => {
    let freeTickets = 0;
    const freeTicketsRates = getFreeTickets(
      result.prize,
      result.generalSettings,
    );
    const actualFreeTicketsObject = filterFreeTicketsRates(
      freeTicketsRates,
      ticketBundle.tickets,
    );
    if (actualFreeTicketsObject) {
      freeTickets = actualFreeTicketsObject.extra;
    }
    return freeTickets + ticketBundle.tickets;
  };

  const totalCost = getTotalPrice();

  // END OF API
  // const isDoublePrize = raffles.length > 1;
  const isDoublePrize = false;
  const handleTitle = (bundle) => {
    // example  £2m Draw x 2,000 tickets
    if (isDoublePrize) {
      const firstPrize = raffles[0];
      const secondPrize = raffles[1];
      const firstPrizeTitle = firstPrize.bundleTitle
        ? firstPrize.bundleTitle
        : firstPrize.title;
      const secondPrizeTitle = secondPrize.bundleTitle
        ? secondPrize.bundleTitle
        : secondPrize.title;

      const firstPrizeName = `${firstPrizeTitle} x ${getTicketsCount()} tickets`;
      const secondPrizeName = `${secondPrizeTitle} x ${getTicketsCount()} tickets`;
      return (
        <React.Fragment>
          <p className="details-rows">
            <span className="details-row">{firstPrizeName}</span>
          </p>
          <p className="details-rows">
            <span className="details-row">{secondPrizeName}</span>
          </p>
        </React.Fragment>
      );
    } else if (raffles.length) {
      return (
        <>
          {/* £2m Draw x 2,000 tickets */}
          <p className="details-rows">
            <span className="details-row">{`${getTicketsCount()} tickets`}</span>
            {/* <span className="details-row discount-tickets">{`${discountTicketsMapText[bundle]} tickets`}</span> */}
          </p>
        </>
      );
    } else {
      return <p>Raffle Title</p>;
    }
  };
  const handlePagediscountTitle = () => {
    return (
      <>
        <p>
          {`${getTicketsCount()} ${raffles[0].title.replace(
            "Cash Draw",
            "",
          )} tickets`}{" "}
        </p>
        {/* <p className='orange'>{`${ticket.tickets} ${raffles[0].title} tickets`}</p> */}
      </>
    );
  };
  // const isDiscount = ticket.totalCost !== calculateDiscountPrice(ticket);
  const labelClassName = label ? labelsClassNames[label] : "";

  const getTicketPrice = () => {
    // const actualDiscount = filterDiscountRates(
    //   result.discountRates,
    //   ticketBundle.tickets,
    // );
    // let price = actualDiscount
    //   ? ticketBundle.tickets * actualDiscount.newPrice
    //   : ticketBundle.tickets * result.prize.ticketPrice;
    const price = ticketBundle.price * ticketBundle.tickets;
    const tiketCost = (price * 100) / getTicketsCount();
    return Math.round(tiketCost - 0.2);
  };

  return (
    <div
      className={[
        "ticket-card",
        ticketBundle.discount === 50 ? "premium" : "small",
        theme === "light" ? "ticket-card_white" : "ticket-card_green",
        labelClassName,
      ].join(" ")}
      onClick={() => {
        if (!loading && !isExpired) {
          onClick({
            numOfTickets: ticketBundle.tickets,
            prizeType: "raffle",
            tickets: getTicketsCount(),
            bonusDraw: bonusDrawId,
          })();
        }
      }}
    >
      <div className="ticket-card__grid">
        <div className="details">
          {isDoublePrize
            ? handleTitle(ticketBundle)
            : type === "pagediscount"
              ? handlePagediscountTitle()
              : handleTitle(ticketBundle)}
          <span className="ticket-price">
            Only {getTicketPrice()}p per ticket
          </span>
        </div>
        <div className="ticket-card__main">
          <div className="price">
            {/* {  <p className='discounted'> {totalCost}</p>} */}
            {/* <p className={isDiscount ? '' : 'no-discount'}>
              £{calculateDiscountPrice(ticket)}
            </p> */}
            {/* {isDiscount && <p className='discounted'>{totalCost}</p>} */}
            {/* <p className="discounted">{oldMapPrice[totalCost]}</p> */}
            <p className={"no-discount"}>{totalCost}</p>
            {/* <p className='per-ticket'>{`${pricePerTicket} per ticket`}</p> */}
          </div>
          <button disabled={loading || isExpired} className="ticket-card__btn">
            {loading && activeTicket === ticketBundle.tickets ? (
              <>
                <Loader text="adding..." />
              </>
            ) : (
              <>Buy now</>
            )}
          </button>
        </div>
        {/* {discountsMapText[ticketBundle.tickets] && (
          <div className="discount">{discountsMapText[ticketBundle.tickets]}</div>
        )} */}
        {/* {ticket.discount > 0 && (
          <div className='discount'>Save {ticket.discount}%</div>
        )} */}
      </div>
    </div>
  );
};

export default TicketCard;
